import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Member } from '../../../shared/interfaces/dealer.interfaces';

const basePath = '/dealer/users';

@Injectable({
  providedIn: 'root'
})

export class DealerUserService {
  constructor(private http: HttpClient) { }

  // Gets all users (members) for the current dealer
  getAllUsers(): Observable<Member[]> {
    return this.http.get<Member[]>(`${basePath}`);
  }

  // Gets a specific member details for the current dealer
  getUserById(userId: number): Observable<Member> {
    return this.http.get<Member>(`${basePath}/${userId}`);
  }
  
  // Updates a member's permissions
  updateUserPermissions(userId: number, permissions: string[]): Observable<Member> {
    let body = null;
    if (permissions.length > 0) {
      body = permissions;
    }
    return this.http.put<Member>(`${basePath}/${userId}`, body);
  }

  // Removes a member from the current dealer
  removeUser(userId: number) {
    return this.http.delete(`${basePath}/${userId}`);
  }

}
